import React from 'react';
import { CircleHelp } from 'lucide-react';

export default function MaintenanceReadyKpi({ count, warningCount, selected, onToggle }) {
  return <div className="crystal-ball__maintenance-kpi">
    <button type="button" className={`reports-kpi-card crystal-ball__kpi-button ${selected ? 'is-active' : ''}`}
      onClick={onToggle} aria-pressed={selected}>
      <span className="reports-kpi-card__label">Maintenance Ready Now</span>
      <strong>{count}{warningCount > 0 ? '*' : ''}</strong>
      <span className="reports-kpi-card__meta">FMC or PMC at selected location with no known Mx blockers within the next 30 days</span>
      {warningCount > 0 ? <span className="crystal-ball__planning-footnote">* {warningCount} counted with missing plans or forecast</span> : null}
    </button>
    <details className="crystal-ball__maintenance-help" onKeyDown={event => {
      if (event.key === 'Escape') {
        event.currentTarget.open = false;
        event.currentTarget.querySelector('summary').focus();
      }
    }}>
      <summary aria-label="Maintenance Ready Now rules" title="Maintenance Ready Now rules"><CircleHelp size={18} aria-hidden="true" /></summary>
      <div className="crystal-ball__maintenance-help-content" role="note">
        <strong>Maintenance Ready Now rules</strong>
        <p>FMC or PMC now, with no known maintenance blocker at any point from now through the next 30 days. Applies to the selected sites, MDS, and homestation/offstation filter.</p>
        <ul>
          <li>Any known maintenance outage in that window excludes the tail, even if it finishes before day 30. Work in progress and recorded starts within the window block; a finish within the window also blocks when the start is missing.</li>
          <li>Unresolved open X jobs block. Other inspections, jobs, and custom tasks are considered only when marked as readiness drivers.</li>
          <li>Overdue requirements, reached hour/cycle limits, and calendar requirements due within 30 days block unless active waiver coverage runs continuously from the due/block date through the end of the window.</li>
          <li>Pending waivers do not clear a blocker. A waiver does not erase a scheduled maintenance outage.</li>
          <li>Missing planned dates alone are warnings, not blockers. Known overdue work and open X jobs still block even without a plan.</li>
          <li>A calculated forecast is not required. The check uses current status and recorded maintenance.</li>
          <li>The asterisk counts otherwise-ready tails with missing driver plans or a missing forecast. Each tail counts once, even with several gaps. Unknown timing is not confirmed clearance.</li>
          <li>Completed/cancelled work is excluded. Current logic also treats a recorded actual or planned finish in the past as cleared.</li>
          <li>Alert, deployment, and being offstation do not by themselves block this maintenance KPI. Aircraft Ready to Fight separately checks availability at homestation.</li>
        </ul>
        <p>Click the KPI to filter Tail Forecast Evidence; click again to clear it. Planning warnings identify which counted tails have incomplete information.</p>
        <button type="button" onClick={event => {
          const details = event.currentTarget.closest('details');
          details.open = false;
          details.querySelector('summary').focus();
        }}>Close</button>
      </div>
    </details>
  </div>;
}
